/*
 * UNIVERSIDAD AUTONOMA DE AGUASCALIENTES
 * DIRECCION GENERAL DE PLANEACION Y DESARROLLO
 * DEPARTAMENTO DE SISTEMAS (OPTIMIZACION DE PROYECTOS ADMINISTRATIVOS - OPA)
 *
 * PROYECTO:  COMPRAS
 * PROPOSITO: Subir propuesta de obra.
 *
 * AUTOR:     GAMORALES
 * FECHA:     05/Nov/2019
 *
*/

import { Component, OnInit, Input,EventEmitter, Output, ViewChild, ElementRef } from '@angular/core';
import { ApiProcedimientosService } from '../../../../../services/api-procedimientos.service';
import { Router } from '@angular/router';
import { Proveedor } from 'src/app/models/Proveedor';
import { DatePipe } from '@angular/common';
import { isNullOrUndefined } from 'util';
import { ApiRegistryService } from '../../../../../services/api-registry.service';
import { ApiAuthService } from '../../../../../services/api-auth.service';
import { Globals } from '../../../../../globals';
import { ApiDownloadFileService } from '../../../../../services/api-download-file.service';
import { ApiUploadFileService } from '../../../../../services/api-upload-file.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';

declare var $: any;


@Component({
  selector: 'subir-propuesta-obra',
  templateUrl: './subir-propuesta-obra.component.html',
  styleUrls: ['./subir-propuesta-obra.component.css']
})
export class SubirPropuestaObraComponent implements OnInit {
  public datosGrales: any[] = [];
  public propuesta: any[] = [];
  private pipe = new DatePipe('es');

  vpnGoddocs: string = '';
  pk_proveedor: string = '';
  comentarios: string = '';

  public files: FileList;
  public vpnMov;
  public vpsTipoProv;
  public vpsCveDoc;

  public mensajeAlerta: string = '';
  public mensajeExito: string = '';
  public tipoAlerta: number;
  public tipoMov: number = 0;

  @Input() public anio: string;
  @Input() public idProc: string;
  @Input() public tipo: string;

  @Output() EventoMenu = new EventEmitter();

  @ViewChild('downloadLink', {static: false}) downloadLink: ElementRef;
  @ViewChild('myInput', {static: false}) myInput: ElementRef;

  public mensajeError: string = '';
  public error: number;

  public montoInvalid: string = '';
  public errorMonto: string = '';

  createFormGroup() {
    return new FormGroup({
      monto: new FormControl('', [Validators.required])
    });
  }

  contactForm: FormGroup;
  constructor(private apiProcedimientos: ApiProcedimientosService,private router: Router,
              private apiRegistry: ApiRegistryService, private apiAuth: ApiAuthService,
              private globals: Globals, private apiDownload: ApiDownloadFileService,
              private apiUpload: ApiUploadFileService) {

      this.contactForm = this.createFormGroup();
  }

  ngOnInit() {
    $('#mod_procesando').modal('show');
    this.readDatosGrales(this.anio, this.idProc, this.tipo);
  }


  readDatosGrales(anio: string, idProcedimiento: string, tipo: string) {
    let proveedor;
    let prov: Proveedor = this.getProveedor();

    // $('#texto_error').text('Ocurrió un error al mostrar la información del procedimiento.');
    this.mensajeError = 'Ocurrió un error al mostrar la información del procedimiento.'

    this.apiRegistry.getInformacionRfc(prov.RFC).subscribe(data => {
      if(data[0].success && data[0].info !== '{}'){
        proveedor = JSON.parse(data[0].info);
        this.pk_proveedor = proveedor[0].PK_FKCPRCO;
        this.apiProcedimientos.getDatosGralesProv(anio, idProcedimiento, proveedor[0].PK_FKCPRCO).subscribe(data => {
          if(data[0].success){
            this.datosGrales = JSON.parse(data[0].info);
            this.contactForm.controls.monto.setValue(this.datosGrales[0].MONTOP);
            // /*Si aun no tiene fecha interes, cambia de estatus a: "PROVEEDOR MOSTRO INTERES"*/
            if (this.datosGrales[0].FECHAINTERES === '') {
              let fechaActual = new Date();

              this.apiProcedimientos.updateProcesoProveedor(anio, idProcedimiento, proveedor[0].PK_FKCPRCO, this.globals.ESTATUS_PROC_PROV_INTERES, null, null, null, null, this.pipe.transform(fechaActual, 'dd/MM/yyyy'))
              .subscribe(data => {
                if (data[0].success) {
                  this.datosGrales[0].FKDPRPR_ESTADO = this.globals.ESTATUS_DESC_PROC_PROV_INTERES;
                  this.datosGrales[0].FKDPRPR_INDEST = this.globals.ESTATUS_PROC_PROV_INTERES;
                }
              });
            }

            this.actualizarMenu(this.datosGrales[0].SUBE_PROP, this.datosGrales[0].VER_PROP);
            this.readDocsPropuesta(this.datosGrales[0].IACTIDO_PK_CVETID, anio, idProcedimiento, tipo, true);
            // this.readArticulos(anio, idProcedimiento, proveedor[0].PK_FKCPRCO);
          } else {
            setTimeout(() => {
              $('#mod_procesando').modal('hide');
              $('#error').modal('show');
            }, 500);
          }
        },
        error => {
          this.error = error.status;
          if (error.status === 401) {
            this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
          } else  {
            this.mensajeError = '¡Error!';
          }
          setTimeout(() => {
            $('#mod_procesando').modal('hide');
            $('#error').modal('show');
          }, 500);
        });
      } else {
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
          $('#error').modal('show');
        }, 500);
      }
    },
    error => {
      this.error = error.status;
      if (error.status === 401) {
        this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
      } else  {
        this.mensajeError = '¡Error!';
      }
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
      }, 500);
    });
  }

  readDocsPropuesta(iActido: string, anio: string, idProcedimiento: string, tipo: string, iniTable: boolean) {
    this.apiProcedimientos.getInfoObra(iActido, anio, idProcedimiento, tipo, this.pk_proveedor).subscribe(data => {
      if(data[0].success){
        this.propuesta = JSON.parse(data[0].info);
        if (iniTable){
          $(document).ready(function () {
            let tbl_anexos = $('#tbl_propuesta').DataTable({
              //dom: '<"#positionFilter">ltp',
        paging: true,       //Oculta controles y etiquetas de paginación
        searching: true,    //Dejar en true para conservar funcionalidades de busqueda en columnas.
        info: false,        //Oculta etiquetas de cantidad de registros disponibles y filtrados.
        autoWidth: false,   //Impide que calcule automaticamente el ancho de las columnas.
        processing: true,
        bSort: false,
        renderer: 'bootstrap',
        dom: "<'row'<'col-sm-10'B><'col-sm-2'>>tp",
        "lengthMenu": [[10, 25, 50, -1], ["Mostrar 10", "Mostrar 25", "Mostrar 50", "Mostrar Todos"]],
        language: {
          "sSearch": "Buscar:",
          "sProcessing": "Procesando...",
          "sLengthMenu": "_MENU_ REGISTROS",
          "sZeroRecords": "No se encontraron resultados",
          "sEmptyTable": "Ningún dato disponible en esta tabla",
          "sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
          "sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
          "sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
          "sInfoPostFix": "",
          "oPaginate": {
              "sFirst": "Primero",
              "sLast": "Último",
              "sNext": "SIGUIENTE",
              "sPrevious": "ANTERIOR"
          },
          buttons: {
              pageLength: {
                  _: '<span><i class="fal fa-list-ul mr-2"></i></span> %d REGISTROS',
                  //1: '<span><i class="fal fa-list-ul mr-2"></i></span> Mostrar Todos',
                  '-1': '<span><i class="fal fa-list-ul mr-2"></i></span> Mostrar Todos'
              }
          }
      },
      buttons: [
            {
              extend: 'pageLength',
              className: 'btn uaa-btn-outline btn-sm dropdown-toggle'
          }
      ]
            });
          });
        }
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
        }, 500);
      } else {
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
          $('#error').modal('show');
        }, 500);
      }
    },
    error => {
      this.error = error.status;
      if (error.status === 401) {
        this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
      } else  {
        this.mensajeError = '¡Error!';
      }
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
      }, 500);
    });
  }

  download(cve_docto: string, nombre: string) {
    this.apiDownload.downloadFile(cve_docto).subscribe(result => {
      let url = window.URL.createObjectURL(result);

      const link = this.downloadLink.nativeElement;
      link.href = url;
      link.download = nombre;
      link.click();

      window.URL.revokeObjectURL(url);
    });
  }

  actualizarMenu(valor: string, propuesta: string){
    /*Actualiza MENU de menu-producto.component.ts*/
    this.EventoMenu.emit({estatusSubir: valor, estatusPropuesta: propuesta });
    // this.estatusProc = valor;
  }

  getProveedor(): Proveedor{
    let prov: Proveedor
    prov = this.apiAuth.getTokenDecoded();

    if (isNullOrUndefined(prov)) {
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
      }, 500);
      return null;
    } else {
      return prov;
    }
  }

  arch(mov: string, cvedoc: string, goddocs: string, tipodocto: string) {
    this.myInput.nativeElement.value = '';
    this.comentarios = '',
    this.vpnMov = mov;
    this.vpsCveDoc = cvedoc;
    this.vpnGoddocs = goddocs;
    this.vpsTipoProv = tipodocto;
    this.mensajeAlerta = '¿Estás seguro que desea eliminar el documento?';
    this.tipoAlerta = 0;
  }

  cargarArchivo(files: FileList) {
    this.files = files;
  }

  reemplazaCaracter(evento) {
    let cadena = evento.target.value;
    cadena = cadena.replace(/["/\\]/g, '');
    cadena = cadena.replace(/[&\\]/g, ' and ');
    evento.target.value = cadena;
    this.comentarios = cadena;
  }

  guardarArchivo() {
    let proveedor: Proveedor;
    proveedor = this.apiAuth.getTokenDecoded();
    if (this.files !== undefined && this.files.length > 0) {
        $('#mod_procesando').modal('show');
        this.apiUpload.postFileObraProcProv(proveedor.Correo,this.vpnMov,this.anio, this.idProc
          , this.pk_proveedor,this.vpsTipoProv,this.vpsCveDoc,this.vpnGoddocs,this.comentarios,this.files[0]).subscribe(data => {
          if (data[0].success) {
            this.tipoMov = 0;
            setTimeout( () => {
              this.mensajeExito = '¡El documento ha sido cargado correctamente!';
              $('#mod_procesando').modal('hide');
              $('#success_exito').modal('show');
            },500);
          } else {
            this.mensajeError = data[0].msgRespuesta;
            setTimeout(() => {
              $('#mod_procesando').modal('hide');
              $('#error').modal('show');
           }, 500);
          }
        },
        error => {
          this.error = error.status;
          if (error.status === 401) {
            this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
          } else  {
            this.mensajeError = '¡Error!';
          }
          setTimeout(() => {
            $('#mod_procesando').modal('hide');
            $('#error').modal('show');
         }, 500);
        });
  } else {
    $('#info').modal('show');
  }
  }

  eliminarArchivo() {
    let proveedor: Proveedor;
    proveedor = this.apiAuth.getTokenDecoded();
    $('#mod_procesando').modal('show');
    this.apiUpload.deleteFileObraProcProv(proveedor.Correo, this.vpnMov, this.anio, this.idProc, this.pk_proveedor,this.vpsTipoProv,this.vpsCveDoc,this.vpnGoddocs).subscribe(data => {
      if (data[0].success) {
        this.tipoMov = 0;
        setTimeout( () => {
          this.mensajeExito = '¡El documento ha sido eliminado correctamente!';
          $('#mod_procesando').modal('hide');
          $('#success_exito').modal('show');
        },500);
      } else {
          this.mensajeError = data[0].msgRespuesta;
          setTimeout(() => {
              $('#mod_procesando').modal('hide');
              $('#error').modal('show');
           }, 500);
      }
    },
    error => {
      this.error = error.status;
      if (error.status === 401) {
        this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
      } else  {
        this.mensajeError = '¡Error!';
      }
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
     }, 500);
    });
  }

  enviar() {
    let bandValida = true;
    for (let i =0; i<this.propuesta.length; i++) {
      if (this.propuesta[i].OBLIGATORIO === '1') {
        if (this.propuesta[i].DOCCARGADO === '') {
          bandValida = false;
        }
      }
    }
    if (bandValida === false){
      this.tipoAlerta = 3;
      this.mensajeAlerta = 'Es necesario cargar todos los archivos pertinentes para completar el proceso.';
      $('#alerta').modal('show');
    } else {
      if (this.validaFechaFin()) {
        if (this.validaCampo()){
          this.procEnviaPropuesta();
        }
      } else {
        this.tipoAlerta = 3;
        this.mensajeAlerta = 'No puedes participar debido a que el tiempo de publicación a terminado.';
        $('#alerta').modal('show');
      }
    }
  }

  procEnviaPropuesta() {
    let proveedor: Proveedor;
    proveedor = this.apiAuth.getTokenDecoded();
    $('#procesando').modal('show');
    let monto = this.contactForm.get('monto').value;
    this.apiProcedimientos.updateEnviPropObra(this.anio, this.idProc, this.pk_proveedor, monto, proveedor.Correo).subscribe(data => {
        if (data[0].success) {
          this.tipoMov = 1;
          setTimeout( () => {
            this.mensajeExito = 'La(s) propuesta(s) ha(n) sido almacenada(s), podrá seguir haciendo modificaciones mientras el procedimiento continue abierto.';
            $('#procesando').modal('hide');
            $('#success_exito').modal('show');
          }, 500);
        } else {
          this.mensajeError = data[0].msgRespuesta;
          setTimeout( () => {
            $('#procesando').modal('hide');
            $('#error').modal('show');
          }, 500);
        }
    },
    error => {
      this.error = error.status;
      if (error.status === 401) {
        this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
      } else  {
        this.mensajeError = '¡Error!';
      }
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
     }, 500);
    });
  }


  validaFechaFin() {
    /*Si la fecha de publicación terminó o es nula regresa False"*/
    let fechaActual = new Date();
    let fechaFinPub = new Date(this.datosGrales[0].FECFINPUB);

    if (isNaN(fechaFinPub.getTime()) || fechaFinPub.getTime() < fechaActual.getTime()){
      return false;
    } else {
      return true;
    }
  }

  validaCampo() {
    let bandValida = true;

    if (this.contactForm.controls.monto.hasError('required')) {
       bandValida = false;
       this.montoInvalid = 'is-invalid';
       this.errorMonto = 'Ingrese el monto';
    } else {
      this.montoInvalid = '';
      this.errorMonto = '';
    }

    return bandValida;
  }

  recargar() {
    this.readDocsPropuesta(this.datosGrales[0].IACTIDO_PK_CVETID, this.anio, this.idProc, this.tipo, true);
      $(document).ready(function () {
        $('#tbl_propuesta').DataTable().destroy();
      });
  }

  cerrarSesion() {
    this.apiAuth.deleteToken();
    this.router.navigate(['/']).then(() => window.location.reload());
  }

}
